import type { ClientOverviewRepository } from "../repositories/ClientOverviewRepository";
import type { LastMonthRevenueInsightsEntity } from "../entities/LastMonthRevenueInsightsEntity";

export class GetLastMonthRevenueInsightsUseCase {
  constructor(private readonly repository: ClientOverviewRepository) {}

  async execute(): Promise<LastMonthRevenueInsightsEntity> {
    return this.repository.getLastMonthRevenueInsights();
  }
}
